import { render, staticRenderFns } from "./BrokerProfile.vue?vue&type=template&id=1f7432e9&scoped=true"
import script from "./BrokerProfile.vue?vue&type=script&lang=js"
export * from "./BrokerProfile.vue?vue&type=script&lang=js"
import style0 from "./BrokerProfile.vue?vue&type=style&index=0&id=1f7432e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7432e9",
  null
  
)

export default component.exports